<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Instructions", @itemRemoved="optionRemoved")
</template>

<script>
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import BaseSelectize from './BaseSelectize'
  import Selectize from "../../../Selectize";

  export default {
    name: "SelectizeInstructions",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.instructions.list.all((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>IN${item.id} ${item.title}</div><div><small>${item.subtitle}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div>IN${item.id} ${item.title}</div><div><small>${item.subtitle}</small></div></div>`
      },
      optionsLoader() {

      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeInstructions.vue?3da11462